
<div class="prefectureLinks">
  <div class="prefectureLinks__listItem">
    <h3>▼北海道・東北エリア</h3>
    <ul>
      <li><a :class="{'white': isWhite}" href="/hokkaido/">北海道</a></li>
      <li><a :class="{'white': isWhite}" href="/aomori/">青森県</a></li>
      <li><a :class="{'white': isWhite}" href="/iwate/">岩手県</a></li>
      <li><a :class="{'white': isWhite}" href="/miyagi/">宮城県</a></li>
    </ul>
    <ul>
      <li><a :class="{'white': isWhite}" href="/akita/">秋田県</a></li>
      <li><a :class="{'white': isWhite}" href="/yamagata/">山形県</a></li>
      <li><a :class="{'white': isWhite}" href="/fukushima/">福島県</a></li>
    </ul>
  </div>
  <div class="prefectureLinks__listItem">
    <h3>▼関東エリア</h3>
    <ul>
      <li><a :class="{'white': isWhite}" href="/ibaraki/">茨城県</a></li>
      <li><a :class="{'white': isWhite}" href="/tochigi/">栃木県</a></li>
      <li><a :class="{'white': isWhite}" href="/gunma/">群馬県</a></li>
      <li><a :class="{'white': isWhite}" href="/saitama/">埼玉県</a></li>
    </ul>
    <ul>
      <li><a :class="{'white': isWhite}" href="/chiba/">千葉県</a></li>
      <li><a :class="{'white': isWhite}" href="/tokyo/">東京都</a></li>
      <li><a :class="{'white': isWhite}" href="/kanagawa/">神奈川県</a></li>
    </ul>
  </div>
  <div class="prefectureLinks__listItem">
    <h3>▼北陸・東海エリア</h3>
    <ul>
      <li><a :class="{'white': isWhite}" href="/niigata/">新潟県</a></li>
      <li><a :class="{'white': isWhite}" href="/toyama/">富山県</a></li>
      <li><a :class="{'white': isWhite}" href="/ishikawa/">石川県</a></li>
      <li><a :class="{'white': isWhite}" href="/fukui/">福井県</a></li>
      <li><a :class="{'white': isWhite}" href="/yamanashi/">山梨県</a></li>
    </ul>
    <ul>
      <li><a :class="{'white': isWhite}" href="/nagano/">長野県</a></li>
      <li><a :class="{'white': isWhite}" href="/gifu/">岐阜県</a></li>
      <li><a :class="{'white': isWhite}" href="/shizuoka/">静岡県</a></li>
      <li><a :class="{'white': isWhite}" href="/aichi/">愛知県</a></li>
    </ul>
  </div>
  <div class="prefectureLinks__listItem">
    <h3>▼近畿エリア</h3>
    <ul>
      <li><a :class="{'white': isWhite}" href="/mie/">三重県</a></li>
      <li><a :class="{'white': isWhite}" href="/shiga/">滋賀県</a></li>
      <li><a :class="{'white': isWhite}" href="/kyoto/">京都府</a></li>
      <li><a :class="{'white': isWhite}" href="/osaka/">大阪府</a></li>
    </ul>
    <ul>
      <li><a :class="{'white': isWhite}" href="/hyogo/">兵庫県</a></li>
      <li><a :class="{'white': isWhite}" href="/nara/">奈良県</a></li>
      <li><a :class="{'white': isWhite}" href="/wakayama/">和歌山県</a></li>
    </ul>
  </div>
  <div class="prefectureLinks__listItem">
    <h3>▼中国地方エリア</h3>
    <ul>
      <li><a :class="{'white': isWhite}" href="/tottori/">鳥取県</a></li>
      <li><a :class="{'white': isWhite}" href="/shimane/">島根県</a></li>
      <li><a :class="{'white': isWhite}" href="/okayama/">岡山県</a></li>
      <li><a :class="{'white': isWhite}" href="/hiroshima/">広島県</a></li>
    </ul>
    <ul>
      <li><a :class="{'white': isWhite}" href="/yamaguchi/">山口県</a></li>
    </ul>
  </div>
  <div class="prefectureLinks__listItem">
    <h3>▼四国エリア</h3>
    <ul>
      <li><a :class="{'white': isWhite}" href="/tokushima/">徳島県</a></li>
      <li><a :class="{'white': isWhite}" href="/kagawa/">香川県</a></li>
      <li><a :class="{'white': isWhite}" href="/ehime/">愛媛県</a></li>
      <li><a :class="{'white': isWhite}" href="/kochi/">高知県</a></li>
    </ul>
  </div>
  <div class="prefectureLinks__listItem">
    <h3>▼九州・沖縄エリア</h3>
    <ul>
      <li><a :class="{'white': isWhite}" href="/fukuoka/">福岡県</a></li>
      <li><a :class="{'white': isWhite}" href="/saga/">佐賀県</a></li>
      <li><a :class="{'white': isWhite}" href="/nagasaki/">長崎県</a></li>
      <li><a :class="{'white': isWhite}" href="/kumamoto/">熊本県</a></li>
    </ul>
    <ul>
      <li><a :class="{'white': isWhite}" href="/oita/">大分県</a></li>
      <li><a :class="{'white': isWhite}" href="/miyazaki/">宮崎県</a></li>
      <li><a :class="{'white': isWhite}" href="/kagoshima/">鹿児島県</a></li>
      <li><a :class="{'white': isWhite}" href="/okinawa/">沖縄県</a></li>
    </ul>
  </div>
</div>
